export default function articlessection(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                articlessection: action.articlessection,
            }
        default:
            return state;
    }
}
